import {TimeUtil} from '../utils/TimeUtil';
import {MatDialog} from '@angular/material/dialog';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Keys, StorageService} from '../service/storage.service';
import {CampaignPopUpComponent} from './campaign-pop-up.component';

@Component({
    template: '',
    selector: 'app-campaign-pop-up-check'
})
export class CampaignPopUpCheckComponent implements OnInit {
    private static readonly ENTRY_DELAY = 1000;

    private readonly matDialog: MatDialog;
    private readonly route: ActivatedRoute;
    private readonly storageService: StorageService;

    constructor(route: ActivatedRoute, matDialog: MatDialog, storageService: StorageService) {
        this.route = route;
        this.matDialog = matDialog;
        this.storageService = storageService;
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe((queryParams) => this.onQueryParamsReceived(queryParams));
    }

    async onQueryParamsReceived(queryParams: Params): Promise<void> {
        if (queryParams.utm_source && !this.isUserLoggedIn()) {
            await this.showContactInformationPopUp(queryParams);
        }
    }

    async showContactInformationPopUp(params: Params): Promise<void> {
        await TimeUtil.sleep(CampaignPopUpCheckComponent.ENTRY_DELAY);
        this.matDialog.open(CampaignPopUpComponent, {
            data: params,
            width: '95%',
            maxWidth: '800px'
        });
    }

    private isUserLoggedIn(): boolean {
        return !!this.storageService.getItem(Keys.TOKEN);
    }
}
